import ProveedoresForm from "./ProveedoresForm";
export default ProveedoresForm;